import { TRADINGACCOUNTSTOTRANSFER__MUTATIONS } from "../mutation-types";
import { TRADINGACCOUNTSTOTRANSFER__ACTIONS } from "../action-types";
import { TRADINGACCOUNTSTOTRANSFER__API } from "@/_helpers/urls";
import http from "@/_helpers/http";

// State
const state = {
  levels: [],
  last12MonthsLevelData: [],
};

// Mutations
const mutations = {
  [TRADINGACCOUNTSTOTRANSFER__MUTATIONS.CLIENTLEVELEARNINGS](state, data) {
    state.levels = data.levels;
    state.last12MonthsLevelData = data.last12MonthsLevelData;
  },
};

const getters = {};

// Actions
const actions = {
  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.CLIENTLEVELEARNINGS]({ commit }) {
    try {
      const { data } = await http().get(
        TRADINGACCOUNTSTOTRANSFER__API.CLIENTLEVELEARNINGS
      );
      commit(TRADINGACCOUNTSTOTRANSFER__MUTATIONS.CLIENTLEVELEARNINGS, data);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
